import React from "react";
import Plus from "../../assets/svgs/Plus";
import Header from "../components/Header";
function Note({ text, date, day }) {
  return (
    <div className="note">
      <div className="bg-gray-100 shadow-xl p-5 m-2 rounded">
        <p>{text}</p>
        <hr className="my-3 w-32 h-0.5 bg-gray-200" />
        <div className="flex flex-col justify-start">
          <h2 className="text-lg font-semibold -mb-1.5">{date}</h2>
          <small>{day}</small>
        </div>
      </div>
    </div>
  );
}
const Notes = ({ LeftNavRef }) => {
  return (
    <div className="w-full px-4 md:px-10 pb-10">
      <Header LeftNavRef={LeftNavRef} />
      <h2 className="text-lg mb-2">Notes</h2>
      <div className="w-full flex justify-end">
        <button className="flex space-x-2 items-center px-4 py-1.5 text-base bg-pink-600 text-white shadow-xl rounded focus:ring">
          <span>Add Notes</span>
          <span className="w-4 h-4 flex items-center justify-center rounded-full shadow bg-pink-500">
            <Plus />
          </span>
        </button>
      </div>

      {/* Notes */}
      <div className="flex flex-wrap justify-center mt-5">
        <Note
          date="16 Apr"
          day="Monday"
          text="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
        sint. Velit officia consequat duis."
        />
        <Note
          date="16 Apr"
          day="Monday"
          text="Amet minim mollit non deserunt est sit aliqua dolor do non deserunt ullamco est."
        />
        <Note
          date="16 Apr"
          day="Monday"
          text="Amet minim mollit  sit non deserunt ullamco aliqua dolor do amet
        sint. Velit officia consequat duis."
        />
        <Note
          date="16 Apr"
          day="Monday"
          text="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
        sint."
        />
        <Note
          date="16 Apr"
          day="Monday"
          text="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
        sint."
        />
        <Note
          date="16 Apr"
          day="Monday"
          text="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
        sint. Velit officia consequat duis."
        />
        <Note
          date="16 Apr"
          day="Monday"
          text="Amet minim mollit  sit non deserunt ullamco aliqua dolor do amet
        sint. Velit officia consequat duis."
        />
        <Note
          date="16 Apr"
          day="Monday"
          text="Amet minim mollit non deserunt est sit aliqua dolor do non deserunt ullamco est."
        />
      </div>
    </div>
  );
};

export default Notes;
